import { render, staticRenderFns } from "./EditUserAccessDialog.vue?vue&type=template&id=0632505f"
import script from "./EditUserAccessDialog.vue?vue&type=script&lang=js"
export * from "./EditUserAccessDialog.vue?vue&type=script&lang=js"
import style0 from "./EditUserAccessDialog.vue?vue&type=style&index=0&id=0632505f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports